import { makeApiTypes } from 'sidecar-utility-library'
import { RSAA } from 'redux-api-middleware'

export const types = {
  ...makeApiTypes('FETCH_SMART_LAYER', 'smartLayer'),
}

// let's pass in query and apiUrl
export const fetchSmartResponse = query => {
  return {
    [RSAA]: {
      endpoint: process.env.SMART_LAYER_API_URL,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': process.env.SMART_LAYER_API_KEY,
      },
      body: JSON.stringify({ query }),
      types: [
        types.FETCH_SMART_LAYER_REQUEST,
        types.FETCH_SMART_LAYER_SUCCESS,
        types.FETCH_SMART_LAYER_ERROR,
      ],
    },
  }
}

export const initialState = {
  busy: false,
  error: null,
}

export default (state = initialState, { type } = {}) => {
  switch (type) {
    case types.FETCH_SMART_LAYER_REQUEST:
      return {
        ...state,
        busy: true,
        error: null,
      }

    case types.FETCH_SMART_LAYER_SUCCESS: {
      return {
        ...state,
        busy: false,
      }
    }

    case types.FETCH_SMART_LAYER_ERROR:
      return {
        ...state,
        busy: false,
        error: 'A smart layer error has occurred',
      }

    default:
      return state
  }
}
